export const HOUSING_SA_DIMENIONS_CODES = [
  "housingdinner",
  "housingdouter",
  "housinghheight",
  "housingllength",
  "housingbwidth",
  "housinghseat",
  "housingmdistance",
  "housingndistance",
] as const;

export const HOUSING_SA_TEMPERATURE_CODES = ["housingtempmin"] as const;

// These cluster groups have actual values defined inside the api endpoint.
// Other cluster groups only contain a code for a facet which holds actual values
export const HOUSING_SA_TRUE_CLUSTERS = ["housingload", "housinglubrication", "housingcoating", "housingmisalignment"];

/**
 * These filters need to grab all values from facets, regardless of cluster items
 */
export const HOUSING_SA_PURE_FACET_FILTERS = ["housinginclhsg", "housinginclbrg"];

export const HOUSING_SA_SINGLE_FACET_CODES = ["housinginclhsg", "housinginclbrg", "housing_type"];

export const HOUSING_SA_MULTI_FACET_CODES = [
  "bearing_type",
  "bearing_design",
  "number_of_bolts",
  "housing_shapes",
  "housing_design",
  "bearing_mounting_type",
  "housing_material",
  "sealing_type",
];

export const HOUSING_SA_ON_CLICK_UPDATE_CODES = [
  ...HOUSING_SA_TRUE_CLUSTERS,
  ...HOUSING_SA_MULTI_FACET_CODES,
  "housing_type",
  "dimensionUnit",
  "temperatureUnit",
];

export const HSA_PAGE_SIZE = 50;

export const NUMBER_OF_BOLTS_CODE = "housing_qty_bolts";
